import React, { FC } from 'react';
import { TooltipTip } from '../../Tooltip';
import TooltipBtn from '../../TooltipBtn';
import classNames from 'classnames';
import validationBtnTipClasses from './styles/validationBtnTip.module.scss';
import validationTooltipClasses from './styles/validationTooltip.module.scss';
import { ControlGroupProps } from '../types';
import { CheckMarkCircleO } from '../../Icons/CheckMarkCircleO';
import { ExclamationCircleO } from '../../Icons/ExclamationCircleO';
import { ExclamationCircle } from '../../Icons/ExclamationCircle';

export const TooltipValidationSection: FC<ControlGroupProps> = (props) => {
	const {
		valid,
		validationMessage,
		className,
		partiallyRequired,
		partiallyRequiredFilled,
		partiallyRequiredHint,
		partiallyRequiredFilledHint,
		previewMode,
		isMobile,
		mobileValidationInTooltip,
	} = props;

	if (valid && !partiallyRequired) {
		return null;
	}

	if (!valid && isMobile && !mobileValidationInTooltip) {
		return null;
	}

	const partiallyRequiredMessage = partiallyRequiredFilled ? partiallyRequiredFilledHint : partiallyRequiredHint;

	const message = !valid ? validationMessage : partiallyRequiredMessage;

	const messageClasses = classNames(validationTooltipClasses.validationTooltip, {
		[validationTooltipClasses.validationTooltip_invalid]: !valid,
		[validationTooltipClasses.validationTooltip_partiallyRequired]: valid && partiallyRequired,
		[validationTooltipClasses.validationTooltip_partiallyRequiredFilled]:
			valid && partiallyRequired && partiallyRequiredFilled,
	});

	const errorTooltipTip = <TooltipTip className={messageClasses}>{message}</TooltipTip>;
	const componentClasses = classNames(
		validationBtnTipClasses.validationBtnTip,
		{
			[validationBtnTipClasses.validationBtnTip_previewMode]: previewMode,
			[validationBtnTipClasses.validationBtnTip_partiallyRequired]: partiallyRequired && valid,
			[validationBtnTipClasses.validationBtnTip_partiallyRequiredFilled]:
				valid && partiallyRequired && partiallyRequiredFilled,
		},
		className,
	);

	let TooltipIcon;
	if (partiallyRequired) {
		TooltipIcon = partiallyRequiredFilled ? CheckMarkCircleO : ExclamationCircleO;
	}

	if (!valid) {
		TooltipIcon = ExclamationCircle;
	}

	return (
		<TooltipBtn
			tabIndex={-1}
			tooltip={errorTooltipTip}
			tooltipPosition='top'
			tooltipAlign='end'
			className={componentClasses}
			dataTestId='tooltipValidationSectionButton'
		>
			<TooltipIcon />
		</TooltipBtn>
	);
};
